// If not installed yet: npm i sweetalert2
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// Expose to Blade inline scripts
window.Swal = Swal;

// Helpers using your Tailwind classes
window.ShowSuccessMessage = (msg) => {
  Swal.fire({
    icon: 'success',
    title: 'Success',
    text: msg,
    showConfirmButton: true,
    buttonsStyling: false,                // use our Tailwind styles
    timer: 10000,                      // <- remove this if you don't want auto-close
    customClass: {
      title: 'swal-title',
      confirmButton: 'swal-confirm',
      container: 'swal-container',
      icon: 'swal-icon',
      text: 'swal-text'
    }
  });
};

window.ShowWarningMessage = (msg) => {
  Swal.fire({
    icon: 'warning',
    title: 'Warning!',
    text: msg,
    showConfirmButton: true,
    buttonsStyling: false,
    timer: 10000,
    customClass: {
      title: 'swal-title',
      confirmButton: 'swal-confirm',
      container: 'swal-container',
      icon: 'swal-icon',
      text: 'swal-text'
    }
  });
};
